var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1250_2924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 14.0004C10.3259 14.333 10.7148 14.5972 11.1441 14.7776C11.5734 14.958 12.0344 15.0509 12.5 15.0509C12.9656 15.0509 13.4266 14.958 13.8559 14.7776C14.2852 14.5972 14.6741 14.333 15 14.0004L19 10.0004C19.663 9.33734 20.0355 8.43806 20.0355 7.50038C20.0355 6.5627 19.663 5.66342 19 5.00038C18.337 4.33734 17.4377 3.96484 16.5 3.96484C15.5623 3.96484 14.663 4.33734 14 5.00038L13.5 5.50038",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 9.99973C13.674 9.66713 13.285 9.4029 12.8558 9.22252C12.4265 9.04213 11.9655 8.94922 11.4999 8.94922C11.0343 8.94922 10.5733 9.04213 10.144 9.22252C9.71474 9.4029 9.32577 9.66713 8.99989 9.99973L4.99989 13.9997C4.33685 14.6628 3.96436 15.562 3.96436 16.4997C3.96436 17.4374 4.33685 18.3367 4.99989 18.9997C5.66293 19.6628 6.56221 20.0353 7.49989 20.0353C8.43757 20.0353 9.33685 19.6628 9.99989 18.9997L10.4999 18.4997",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1250_2924"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkBlack);
export default __webpack_public_path__ + "static/media/link-black.5b4df8e7641e9045795b09add1050a58.svg";
export { ForwardRef as ReactComponent };